import React, { createContext, useContext, useMemo } from 'react';
import { useSetState } from 'react-use';
import { Step } from 'react-joyride';

interface DashboardTourState {
  run: boolean;
  stepIndex: number;
  steps: Step[];
  tourActive: boolean;
}

const INITIAL_APP_STATE = {
  run: false,
  stepIndex: 0,
  steps: [],
  tourActive: false,
};

export const DashboardTourContext = createContext({
  state: INITIAL_APP_STATE,
  setState: () => undefined,
});
DashboardTourContext.displayName = 'DashboardTourContext';

export function DashboardTourProvider(props: any) {
  const [state, setState] = useSetState(INITIAL_APP_STATE);

  const value = useMemo(
    () => ({
      state,
      setState,
    }),
    [setState, state]
  );

  return <DashboardTourContext.Provider value={value} {...props} />;
}

export function useDashboardTourContext(): {
  setState: (
    patch:
      | Partial<DashboardTourState>
      | ((previousState: DashboardTourState) => Partial<DashboardTourState>)
  ) => void;
  state: DashboardTourState;
} {
  const context = useContext(DashboardTourContext);

  if (!context) {
    throw new Error(
      'useDashboardTourContext must be used within a DashboardTourProvider'
    );
  }

  return context;
}
